import Heading from 'components/Luxkit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React, { PropsWithChildren, ReactElement } from 'react'
import styled, { css } from 'styled-components'

const Container = styled.div`
  display: grid;
  grid-template:
    "center"
    "end"
    "start";

  ${mediaQueryUp.tablet} {
    grid-template: "start center end" / 1fr auto 1fr;
  }
`

const Title = styled(Heading)`
  grid-area: center;
  justify-self: center;
`

const GAP = 8

const sideSlotStyle = css`
  align-self: center;
  padding-block-start: ${rem(GAP)};
  ${mediaQueryUp.tablet} {
    padding-block-start: unset;
  }
  &:empty { display: none }
`

const Start = styled.div`
  ${sideSlotStyle}
  grid-area: start;
  ${mediaQueryUp.tablet} {
    justify-self: start;
    padding-inline-end: ${rem(GAP)};
  }
`

const End = styled.div`
  ${sideSlotStyle}
  grid-area: end;
  ${mediaQueryUp.tablet} {
    justify-self: end;
    padding-inline-start: ${rem(GAP)};
  }
`

interface Props extends PropsWithChildren {
  className?: string
  start?: ReactElement
  end?: ReactElement
}

function TourV2SectionTitle({
  children,
  className,
  start,
  end,
}: Props) {
  return <Container className={className}>
    <Title variant="heading2" align="center" className="section-title">
      {children}
    </Title>
    {!!start && <Start>{start}</Start>}
    {!!end && <End>{end}</End>}
  </Container>
}

export default TourV2SectionTitle
